import React from 'react';
import ngLogo from '../assets/ng_logo.png';

const MaraSportsLogo = ({ className = "h-10", size }) => {
    return (
        <img
            src={ngLogo}
            alt="NextGen Tournaments"
            className={size ? undefined : className}
            style={size ? { height: size, width: 'auto' } : undefined}
            data-testid="app-logo"
        />
    );
};

export default MaraSportsLogo;
